import axios from 'axios';

const Ajax = axios.create();

const loadRemoteScriptCallback = (name, version) => {
  window[name] = window[name] || {};
  window[name].version = window[name].version || version;
};

window.loadRemoteScriptCallback = loadRemoteScriptCallback;

const loadRemoteComponent = ({ name, version, url, isDep, callback }) => {
  if (window[name] && (isDep || window[name].version === version)) {
    return;
  }

  const scriptElement = document.createElement('script');

  scriptElement.setAttribute('src', `${url}?version=${version}`);
  scriptElement.setAttribute('type', 'text/javascript');
  scriptElement.setAttribute('onload',
    callback || `loadRemoteScriptCallback('${name}', '${version}')`);
  document.body.appendChild(scriptElement);
};

export const loadRemoteStyle = ({ href, version }) => {
  if (window.remoteStyles
    && window.remoteStyles[href]
    && window.remoteStyles[href].version === version) {
    return;
  }

  const styleElement = document.createElement('link');

  styleElement.setAttribute('href', `${href}?version=${version}`);
  styleElement.setAttribute('rel', 'stylesheet');
  styleElement.setAttribute('type', 'text/css');
  document.head.appendChild(styleElement);
  window.remoteStyles = window.remoteStyles || {};
  window.remoteStyles[href] = { version };
};

export const loadRemoteManifest = async ({ url, callback }) => {
  const { status, data } = await Ajax.get(url);
  const MAX_RETRY_TIMES = 2000;
  let count = 0;

  if (status !== 200) {
    return;
  }

  // { version: string; entry: { name, path }; deps: [{ name, path }]; styles: [string] }
  const { version, entry, deps = [], styles = [] } = data;

  const loadDeps = deps.reduce((arr, { name, path, require }) => {
    if (window[name]) {
      return arr;
    }

    const loadRemoteComponentProps = {
      isDep: true,
      version,
      name,
      url: path,
    };

    const loadDep = () => {
      if (require && require.some((reqName) => !window[reqName])) {
        setTimeout(loadDep, 100);
      } else {
        loadRemoteComponent(loadRemoteComponentProps);
      }
    };

    loadDep();

    arr.push(loadRemoteComponentProps);

    return arr;
  }, []);

  styles.forEach((href) => {
    loadRemoteStyle({ href, version });
  });

  const loadEntry = () => {
    count += 1;

    if (count > MAX_RETRY_TIMES) {
      // max request time is 200s
      throw new Error('Request timed out');
    }

    if (loadDeps.every(({ name }) => window[name])) {
      window[`${entry.name}Callback`] = () => {
        const component = window[entry.name].default;
        callback(() => component);
      };

      loadRemoteComponent({
        name: entry.name,
        url: entry.path,
        version,
        callback: `${entry.name}Callback()`,
      });
    } else {
      setTimeout(loadEntry, 100);
    }
  };

  loadEntry();
};
